module.exports = __webpack_public_path__ + "86b6f16854bd56892a7021b6cdc000c0.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_4_0.woff
// module id = 541
// module chunks = 0